import React, { Fragment, useEffect, useState } from 'react';
import usePayment from 'state/payment/hooks/usePayment';
import GatewaySummary from './gatewayTransactionCards/summary';
import GatewayPaymentDetails from './gatewayTransactionCards/paymentDetails';
import GatewayPaymentMethod from './gatewayTransactionCards/paymentMethod';
import GatewayPaymentBreakDown from './gatewayTransactionCards/paymentBreakDown';
import NoDetails from './NoDetails';

const GatewayTransactionDetails = (): JSX.Element => {
  // checking data availability
  const [isDataAvailable, setIsDataAvailable] = useState(false);

  const { payment } = usePayment();

  useEffect(() => {
    if (Object.keys(payment?.gatewayTransaction).length) {
      setIsDataAvailable(true);
    } else {
      setIsDataAvailable(false);
    }
  }, [payment.gatewayTransaction]);

  useEffect(() => {
    if (payment.error?.fetchGatewayTransaction) {
      setIsDataAvailable(false);
    }
  }, [payment.error]);

  return (
    <Fragment>
      {isDataAvailable ? (
        <div className="md:px-0 px-4">
          <GatewaySummary info={payment?.gatewayTransaction} />
          <GatewayPaymentDetails info={payment?.gatewayTransaction} />
          <GatewayPaymentBreakDown info={payment?.gatewayTransaction} />
          <GatewayPaymentMethod info={payment?.gatewayTransaction} />
        </div>
      ) : (
        <NoDetails />
      )}
    </Fragment>
  );
};

export default GatewayTransactionDetails;
